// Club product page buy box (snippets/bundle-product-form.liquid).
// Frequency and Level are button groups over hidden selects; the "How do you
// want to pay?" cards pick a length (1 = pay per box, or 3/6/12 prepaid).
// Each length is its own product, listed in hidden .product_N_months blocks
// whose options carry the variant id and price for every level.
$(document).ready(function () {
  var $frequency = $('#product-option-1');
  var $level = $('#product-option-2');
  if (!$frequency.length || !$level.length) return;

  // "$1,430.00" -> 1430
  function toNumber(text) {
    return parseFloat(String(text || '').replace(/[^0-9.]/g, ''));
  }

  // "$145.00" -> "$145"; keeps cents when there are any.
  function shortMoney(text) {
    return String(text || '').replace(/\.00$/, '');
  }

  function choice() {
    var months = $('.mothly-product.active').attr('data-month') || '1';
    return {
      frequency: String($frequency.val()).toLowerCase(),
      level: $level.val(),
      months: months
    };
  }

  function optionFor(months, frequency, level) {
    return $('.product_' + months + '_months.' + frequency).find("select option[value='" + level + "']");
  }

  function savePercent(price, compare) {
    var p = toNumber(price);
    var c = toNumber(compare);
    if (!c || !p || c <= p) return 0;
    return Math.round(((c - p) / c) * 100);
  }

  function renderCards(frequency, level) {
    $('.mothly-product').each(function () {
      var $card = $(this);
      var months = $card.attr('data-month');
      var $option = optionFor(months, frequency, level);
      var price = $option.attr('data_var_price');
      var compare = $option.attr('data_var_compare_price');
      var save = savePercent(price, compare);
      $card.find('.monthly_price .money').text(shortMoney(price));
      if (months === '1') return;
      $card.find('.monthly_price .compare_price').text(save ? shortMoney(compare) : '');
      // On 12 boxes the saving is one free box; say that instead of a %.
      var free = $card.attr('data-free');
      $card.find('.monthly_price .discount').text(save ? (free || 'Save ' + save + '%') : '');
    });
  }

  function renderPrice(frequency, level, months) {
    var $option = optionFor(months, frequency, level);
    var price = $option.attr('data_var_price');
    var compare = $option.attr('data_var_compare_price');
    var $price = $('.bundel-price');

    $price.find('.price.price--sale .money').text(price || '');
    $price.find('.compare-at-price .money').text(compare || '');

    var c = toNumber(compare);
    var p = toNumber(price);
    if (c && p && c !== p) {
      var save = c - p;
      $price.find('.sale.savings').html(
        'You Save <span class="per">' + Math.round((save / c) * 100) + '%</span> (<span class="money">$' + save.toFixed(2) + '</span>)'
      );
    } else {
      $price.find('.sale.savings').html('');
    }

    $('[data-pm-sticky-price]').text(shortMoney(price));
  }

  function renderShipping(months) {
    var $ship = $('[data-pm-ship]');
    if (!$ship.length) return;
    var perBox = toNumber($ship.attr('data-per-box'));
    var boxes = parseInt(months, 10) || 1;
    var text;
    if (boxes === 1) {
      text = '+ $' + perBox + ' shipping per box, added at checkout.';
    } else {
      text = '+ $' + perBox * boxes + ' shipping for ' + boxes + ' boxes ($' + perBox + ' each), added at checkout.';
    }
    $ship.find('[data-pm-ship-text]').text(text);
  }

  function renderSticky(c) {
    var frequency = $frequency.closest('.product-option').find('.swatch_cls.active').text().trim();
    var length = c.months === '1' ? 'per box' : 'prepay ' + c.months;
    $('[data-pm-sticky-choice]').text([c.level, frequency, length].join(' · '));
  }

  function render() {
    var c = choice();
    renderCards(c.frequency, c.level);
    renderPrice(c.frequency, c.level, c.months);
    renderShipping(c.months);
    renderSticky(c);
  }

  // Button groups set their hidden select.
  $('.swatch_cls').on('click', function () {
    var $button = $(this);
    var $group = $button.closest('.product-option');
    $group.find('.swatch_cls').removeClass('active').attr('aria-pressed', 'false');
    $button.addClass('active').attr('aria-pressed', 'true');
    $group.find('select').val($button.attr('data-value')).trigger('change');
  });

  $frequency.add($level).on('change', render);

  // Exactly one length is always chosen; "Pay per box" is the default.
  $('.mothly-product').on('click', function () {
    var $card = $(this);
    if ($card.hasClass('active')) return;
    $('.mothly-product').removeClass('active').attr('aria-pressed', 'false');
    $card.addClass('active').attr('aria-pressed', 'true');
    render();
  });

  render();

  $('.bundle_add_to_cart').on('click', function () {
    var $button = $(this);
    if ($button.prop('disabled')) return;
    var c = choice();
    var isGift = $('input.gift-check').prop('checked');
    var group = '.product_' + c.months + '_months.' + c.frequency + (isGift ? '-gift' : '');
    var data = {
      id: $(group).find("select option[value='" + c.level + "']").attr('data_var_id'),
      quantity: 1,
      selling_plan: $(group).find('.selling_plan').val()
    };
    if (isGift) data['properties[gift_message]'] = $('.gift-textarea textarea').val();

    $button.prop('disabled', true);
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function () {
        window.location.href = '/cart';
      },
      error: function () {
        $button.prop('disabled', false);
        window.alert('Sorry, that could not be added to your cart. Please try again.');
      }
    });
  });

  $('input.gift-check').on('click', function () {
    $('.gift-textarea').toggle($(this).prop('checked'));
  });

  // Sticky bar on phones while the real button is off screen.
  var sticky = document.querySelector('[data-pm-sticky-buy]');
  var addButton = document.querySelector('.bundle_add_to_cart');
  if (sticky && addButton && 'IntersectionObserver' in window) {
    var phone = window.matchMedia('(max-width: 798px)');
    var buttonVisible = true;
    var update = function () {
      var show = phone.matches && !buttonVisible;
      sticky.hidden = !show;
      document.body.classList.toggle('pm-sticky-buy-on', show);
    };
    new IntersectionObserver(function (entries) {
      buttonVisible = entries[0].isIntersecting;
      update();
    }).observe(addButton);
    if (phone.addEventListener) phone.addEventListener('change', update);
    $(sticky).find('[data-pm-sticky-add]').on('click', function () {
      $(addButton).trigger('click');
    });
  }
});
